import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { MdLogin } from "react-icons/md";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import * as yup from "yup";

const buildValidation = (errors) =>
  yup.object().shape({
    username: yup.string().required(errors.REQUIRED),
    password: yup.string().required(errors.REQUIRED),
  });

const CredentialsForm = ({ onSubmit, onLinkClick }) => {
  const { t: auth } = useTranslation(NAME_SPACES.AUTH);
  const { t: errors } = useTranslation(NAME_SPACES.ERRORS);
  const SIGN_IN = auth("SIGN_IN", {
    returnObjects: true,
  });
  const VALIDATIONS = errors("VALIDATIONS", {
    returnObjects: true,
  });
  return (
    <Formik
      initialValues={{ username: "", password: "" }}
      onSubmit={onSubmit}
      validationSchema={buildValidation(VALIDATIONS)}
      validateOnBlur
      validateOnChange={false}
    >
      {({ handleSubmit, ...formProps }) => (
        <div className="auth__body">
          <Input
            label={SIGN_IN.EMAIL}
            placeholder={SIGN_IN.EMAIL}
            {...bindInputProps({
              name: "username",
              ...formProps,
            })}
          />
          <Input
            type="password"
            label={SIGN_IN.PASSWORD}
            placeholder={SIGN_IN.PASSWORD}
            {...bindInputProps({
              name: "password",
              ...formProps,
            })}
          />
          <Button type="primary" onClick={handleSubmit}>
            {SIGN_IN.SUBMIT}
            <MdLogin size={16} />
          </Button>
          <span className="auth__link" onClick={onLinkClick}>
            {SIGN_IN.LINK}
          </span>
        </div>
      )}
    </Formik>
  );
};

export default CredentialsForm;
